import React, {useState, useEffect} from "react";
import {Checkbox, Divider, Form, Radio, Select} from "antd";
import axios from "./axios";

export const RECIPIENT_OBJ = {
    MULTIPLE_CLASSES: {name: 'Multiple classes', display: 'Classes', val: 'MULTIPLE_CLASSES', inputLabel: 'Classes', multipleDropDown: true},
    SINGLE_CLASS: {name: 'Single class', display: 'Students in Class', val: 'SINGLE_CLASS', inputLabel: 'Class', multipleDropDown: false}
};

export const RECIPIENT_ARR = [RECIPIENT_OBJ.MULTIPLE_CLASSES, RECIPIENT_OBJ.SINGLE_CLASS];

export const RECIPIENT_GROUP_OBJ = {
    WORLD: {name: 'World', display: 'World', val: 'WORLD'},
    SCHOOLWIDE: {name: 'Schoolwide', display: 'Schoolwide', val: 'SCHOOLWIDE'},
    CLASSES: {name: 'Classes', display: 'Classes', val: 'CLASSES'},
    STUDENTS: {name: 'Students', display: 'Students', val: 'STUDENTS'},
    STUDENT_SELF: {name: 'Student', display: 'Student', val: 'STUDENT_SELF'}
}

const RecipientSelect = props => {
    const {form, classes, defaultRecipientVals, setRecipientObj} = props;
    const [recipientType, setRecipientType] = useState(defaultRecipientVals?.recipientType ? defaultRecipientVals.recipientType : RECIPIENT_OBJ.SINGLE_CLASS);
    const [students, setStudents] = useState([]);
    const [studentIds, setStudentIds] = useState([]);
    const [initialStudentIds, setInitialStudentIds] = useState([]);
    const [classIds, setClassIds] = useState([]);
    const initialClassIds = classes.map(clazz => {return clazz.classId});

    useEffect(() => {
        form.setFieldValue('recipient', recipientType.val);
        if (defaultRecipientVals?.classIds) {
            form.setFieldValue('classIds', defaultRecipientVals.classIds);

            if (defaultRecipientVals.classIds.length === 1) {
                getStudentsInClass(defaultRecipientVals.classIds[0], defaultRecipientVals?.studentIds);
            }
        }
    }, []);

    useEffect(() => {
        setRecipientObj({
            studentIds: studentIds,
            classIds: classIds,
            recipientType: recipientType,
            recipientGroup: studentIds.length !== initialStudentIds.length ? RECIPIENT_GROUP_OBJ.STUDENTS : RECIPIENT_GROUP_OBJ.CLASSES
        });
    }, [classIds, studentIds, recipientType]);

    const onRecipientChange = ({target: {value}}) => {
        let setVal = [],
            classVal = form.getFieldValue('classIds');

        if (value == RECIPIENT_OBJ.MULTIPLE_CLASSES.val) {
            if (classVal !== undefined && !Array.isArray(classVal)) {
                setVal = [classVal];
            }
            resetStudentDropDown();
        } else {
            if (classVal && classVal.length === 1 && classVal[0]) {
                setVal = classVal[0];
                getStudentsInClass(setVal);
            } else {
                setVal = undefined;
                resetStudentDropDown();
            }
        }

        setClassIds(setVal);
        form.setFieldValue('classIds', setVal);
        setRecipientType(RECIPIENT_OBJ[value]);
    }

    const onClassChange = value => {
        if (recipientType.val === RECIPIENT_OBJ.SINGLE_CLASS.val) {
            if (value) {
                getStudentsInClass(value);
            } else {
                resetStudentDropDown();
            }
        }
    }

    const resetStudentDropDown = () => {
        setStudents([])
        setStudentIds([]);
        setInitialStudentIds([]);
        form.setFieldValue('studentIds', []);
    }

    const getStudentsInClass = (classId, initialIds) => {
        axios.get('/web/ui/sc/studentsInClass', {params: {classId: classId}})
            .then(response => {
                if (response.data) {
                    const studentsData = response.data;
                    setStudents(studentsData);
                    const ids = studentsData.map(student => {return student.userId});
                    setStudentIds(initialIds ? initialIds : ids);
                    setInitialStudentIds(ids);
                    form.setFieldValue('studentIds', initialIds ? initialIds : ids);
                    form.validateFields(['studentIds']);
                }
            }).catch(error => {
                console.error('Error loading students. ', error);
            });
    }

    const handleSelectAllClassIds = event => {
        if (event.target.checked) {
            setClassIds(initialClassIds);
            form.setFieldValue('classIds', initialClassIds);
        } else {
            deselectAllClassSelect();
        }
    }

    const handleSelectAllStudentIds = event => {
        if (event.target.checked) {
            setStudentIds(initialStudentIds);
            form.setFieldValue('studentIds', initialStudentIds);
        } else {
            deselectAllStudentSelect();
        }
    }

    const deselectAllClassSelect = () => {
        form.setFieldValue('classIds', []);
        setClassIds([]);
    }

    const deselectAllStudentSelect = () => {
        form.setFieldValue('studentIds', []);
        setStudentIds([]);
    }

    const handleClassChange = value => {
        setClassIds(value);
    }

    const handleStudentChange = value => {
        setStudentIds(value);
    }

    return (
        <>
            {(defaultRecipientVals?.isInProgress && defaultRecipientVals?.assignedToStudents) &&
                <Form.Item label={`Student${(defaultRecipientVals?.studentIds.length > 1 ? `s` : ``)}`}>
                    {students?.filter(student => defaultRecipientVals?.classIds?.includes(student.classId)).map((student, index) => {
                        const connector = index === 0 ? '' : ', ';
                        return (
                            <span key={student.userId} className={'ch-text-emphasis'}>{`${connector}${student.fullName}`}</span>
                        )
                    })}
                    <span className={'ch-text-emphasis'}>{defaultRecipientVals?.studentNames}</span>
                </Form.Item>
            }
            {(defaultRecipientVals?.isInProgress && !defaultRecipientVals?.assignedToStudents) &&
                <Form.Item label={recipientType.inputLabel}>
                    {classes.filter(clazz => defaultRecipientVals?.classIds?.includes(clazz.classId)).map((clazz, index) => {
                        const connector = index === 0 ? '' : ', ';
                        return (
                            <span key={clazz.classId} className={'ch-text-emphasis'}>{`${connector}${clazz.className}`}</span>
                        )
                    })}
                </Form.Item>
            }
            {!defaultRecipientVals?.isInProgress &&
                <>
                    <Form.Item label={'Recipient'} name={'recipient'}>
                        <Radio.Group
                            optionType="button"
                            buttonStyle={'solid'}
                            onChange={onRecipientChange}
                            options={RECIPIENT_ARR.map(recipientType => {
                                return {label: recipientType.name, value: recipientType.val}
                            })}
                        />
                    </Form.Item>
                    <Form.Item
                        label={recipientType.inputLabel}
                        name={'classIds'}
                        rules={[
                            {
                                required: true,
                                message: 'Select at least one class.',
                            },
                            {
                                message: 'Maximum 5 classes.',
                                validator: (_, val) => {
                                    if (val && val.length > 5) {
                                        return Promise.reject('You can only assign a maximum of 5 classes.');
                                    }
                                    return Promise.resolve();
                                },
                            },
                        ]}
                    >
                        <Select
                            onSelect={onClassChange}
                            virtual={false}
                            showSearch={false}
                            popupRender={(menu) => (
                                <>
                                    {menu}
                                    {recipientType.multipleDropDown &&
                                        <>
                                            <Divider style={{margin: '0 0 4px 0'}}/>
                                            <div className={'edit-assign-dialog select-checkbox-wrapper'}>
                                                <Checkbox
                                                    disabled={initialClassIds && initialClassIds.length === 0}
                                                    checked={initialClassIds && classIds && initialClassIds.length === classIds.length}
                                                    onChange={handleSelectAllClassIds}
                                                >
                                                    Select all classes
                                                </Checkbox>
                                            </div>
                                        </>
                                    }
                                </>
                            )}
                            allowClear
                            autoClearSearchValue
                            onChange={handleClassChange}
                            onClear={resetStudentDropDown}
                            mode={recipientType.multipleDropDown ? 'multiple' : undefined}
                            maxTagCount={'responsive'}
                        >
                            {classes.map((clazz) => {
                                return (
                                    <Select.Option key={clazz.classId} value={clazz.classId}>
                                        {clazz.className}
                                    </Select.Option>
                                );
                            })}
                        </Select>
                    </Form.Item>
                    {recipientType.val == RECIPIENT_OBJ.SINGLE_CLASS.val &&
                        <Form.Item
                            label={'Students'}
                            name={'studentIds'}
                            rules={[
                                {
                                    required: true,
                                    message: 'Select at least one student.',
                                },
                            ]}
                        >
                            <Select
                                virtual={false}
                                showSearch={false}
                                popupRender={(menu) => (
                                    <>
                                        {menu}
                                        <Divider style={{margin: '0 0 4px 0'}}/>
                                        <div className={'edit-assign-dialog select-checkbox-wrapper'}>
                                            <Checkbox
                                                disabled={initialStudentIds.length === 0}
                                                checked={initialStudentIds.length === studentIds.length}
                                                onChange={handleSelectAllStudentIds}
                                            >
                                                Select all students
                                            </Checkbox>
                                        </div>
                                    </>
                                )}
                                allowClear
                                autoClearSearchValue
                                onChange={handleStudentChange}
                                mode={'multiple'}
                                maxTagCount={'responsive'}
                            >
                                {students.map((student) => {
                                    return (
                                        <Select.Option key={student.userId} value={student.userId}>
                                            {student.fullName}
                                        </Select.Option>
                                    );
                                })}
                            </Select>
                        </Form.Item>
                    }
                </>
            }
        </>
    )
}

export default RecipientSelect;